import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Grid, Pill } from '../../shared';
import { NoGridData } from '../../../components/shared/grid-no-data/no-grid-data';
import { formatCurrency } from '../../../shared';
import { LoaderWrapper } from '../../../shared/utils/loader/loader-wrapper';
import { useLoader } from '../../../shared/utils';
import { loaderConstant } from '../../../shared/types/constants';
export var CaseDashboard = function (_a) {
    var caseDetails = _a.caseDetails, pageSize = _a.pageSize, pageFunction = _a.pageFunction, sortFunction = _a.sortFunction, noOfCases = _a.noOfCases;
    var _b = useState(1), pageCount = _b[0], setPageCount = _b[1];
    var caseTableIsLoading = useLoader({ identifier: 'caseTable' }).caseTableIsLoading;
    var columns = [
        {
            id: 'applicationId',
            description: 'Case Id',
        },
        {
            id: 'applicationStage',
            description: 'Application Stage',
        },
        {
            id: 'applicationStatusId',
            description: 'Status',
            render: function (column, row) {
                var appStatus = row[column.id];
                return React.createElement(Pill, { status: appStatus }, row[column.id]);
            },
        },
        {
            id: 'productName',
            description: 'Product Selected',
        },
        {
            id: 'loanAmount',
            description: 'Loan Value',
            render: function (column, row) {
                return React.createElement(React.Fragment, null, formatCurrency(row[column.id]));
            },
        },
        {
            id: 'ltvValue',
            description: 'LTV',
        },
        {
            id: 'lastUpdatedDate',
            description: 'Date of last action',
            render: function (column, row) {
                var _a;
                var date = new Date(Date.parse((_a = row[column.id]) !== null && _a !== void 0 ? _a : Date.now));
                return React.createElement(React.Fragment, null, date.toLocaleDateString('en-GB'));
            },
        },
        {
            id: 'customerName',
            description: 'Main Applicant Name',
            render: function (column, row) {
                return React.createElement(React.Fragment, null, "".concat(row.customerName));
            },
        },
        {
            id: 'email',
            description: 'Number & Email',
            render: function (column, row) {
                return React.createElement(React.Fragment, null, "".concat(row.email, " ").concat(row.telephone));
            },
        },
        {
            id: 'continue',
            description: 'Actions',
            sort: false,
            render: function (column, row) {
                return (React.createElement("div", { style: { display: 'flex', gap: 20 } },
                    row.isContinueEnable && (React.createElement(Link, { to: "cases/application/".concat(row.applicationId), className: "c-btn c-btn--secondary" }, "Continue")),
                    React.createElement(Link, { to: "cases/case/".concat(row.applicationId), className: "c-btn c-btn--secondary" }, "View")));
            },
        },
    ];
    useEffect(function () {
        var _a;
        var count = 1;
        if (caseDetails && caseDetails.length > 0)
            count = ((_a = caseDetails[0]) === null || _a === void 0 ? void 0 : _a.totalRowCount) || 1;
        setPageCount(count);
    }, [caseDetails]);
    return (React.createElement(React.Fragment, null,
        React.createElement(LoaderWrapper, { type: "table", identifier: "caseTable" },
            React.createElement(Grid, { columns: columns, rowData: caseTableIsLoading ? [] : caseDetails, maxPage: pageCount, pageSize: pageSize, gotoPage: pageFunction, sortRows: sortFunction, noRowsMessage: React.createElement(NoGridData, { image: 'no-clients', message: caseTableIsLoading
                        ? loaderConstant.loadingText
                        : noOfCases === 0
                            ? 'You currently have no cases'
                            : 'No matching records found' }), defaultDirection: "Desc", defaultSortColumn: "applicationId" }))));
};
